import React from 'react';
import ArticleEditorComponent from '../../../components/article-editor';

const ArticleEditor = (props) => (
  <ArticleEditorComponent {...props}/>
)

export default ArticleEditor;
